import { useState, useEffect, useContext } from 'react';
import {
  Table,
  Container,
  Button,
  SpaceBetween,
  Header,
  Box,
  ExpandableSection,
  Select,
  Textarea,
  Spinner,
  TextFilter,
  Modal,
  Multiselect,
  Icon
} from '@cloudscape-design/components';
import { useSearchParams } from 'react-router-dom';
import { getRowColor } from '../helpers/getRowColor';
import { createData } from '../helpers/createCSV';
import { createMultiDocSheet } from '../helpers/createExcelMultiDoc';
// interfaces
import { sentenceItem } from '../models/interfaces';
import { KnowledgeBaseModal } from './Components/KnowledgeBaseModal';

//contexts
import { DocumentContext } from '../context/documentContext';
import { useCollection } from '@cloudscape-design/collection-hooks';
import { DocumentSynopsys } from './Components/DocumentSynopsis';
import { OptionDefinition } from '@cloudscape-design/components/internal/components/option/interfaces';
import { redlineNotes } from '../helpers/redlineNotes';
import { KBIcon } from './Components/kbIcon';
import { getOwnership } from '../helpers/getOwnership';
// import dummy data
export const DocumentViewer = (props: { setShowSynopsis: () => void }) => {
  // contexts
  const {
    domains,
    controls,
    sentences,
    selectedDomainOption,
    selectedControlOptions,
    setSelectedDomainOption,
    setSelectedControlOptions,
    createPhrase,
    currentDoc,
    currentDocId,
    setCurrentDocId,
    selectType,
    setSelectType,
    selectedItems,
    setSelectedItems,
    updateSentence,
    notesValue,
    setNotesValue,
    breakPhraseApart,
    updateFocus,
    updateRedline,
    updateSentenceLoading
  } = useContext(DocumentContext);
  // state for component

  const [currentText, setCurrentText] = useState<string>('');

  const [selectDomains, setSelectDomains] = useState<
    { label: string; value: string }[]
  >([]);
  const [selectControls, setSelectControls] = useState<
    { label: string; value: string }[]
  >([]);
  const [filteredControlOptions, setFilteredControlOptions] = useState<
    { label: string; value: string }[]
  >([]);
  const [queryParameters] = useSearchParams();
  const [showExpansion, setShowExpansion] = useState<boolean>(false);
  const [showSaveButton, setShowSaveButton] = useState<boolean>(false);
  // const [showModal, setShowModal] = useState<boolean>(true);

  const [filteringValue, setFilteringValue] = useState<OptionDefinition[]>([]);
  const [ownershipFilteringValue, setOwnershipFilteringValue] = useState<
    OptionDefinition[]
  >([]);
  const [filteredSentences, setFilteredSentences] = useState<sentenceItem[]>(
    []
  );
  const [burdenAttribution, setBurdenAttribution] = useState<
    {
      label: string;
      value: string;
    }[]
  >([]);
  const { items, actions, filterProps } = useCollection(filteredSentences, {
    filtering: {
      empty: <></>,
      noMatch: (
        <Button onClick={() => actions.setFiltering('')}>Clear filter</Button>
      )
    },
    sorting: {},
    selection: {}
  });
  // useEffect(() => {
  //   if (selectedItems.length > 0) {
  //     setShowExpansion(true);
  //   } else {
  //     setShowExpansion(false);
  //   }
  // }, [selectedItems]);

  useEffect(() => {
    setFilteredSentences(sentences);
  }, [sentences]);
  useEffect(() => {});

  useEffect(() => {
    const tempDomain = [];
    const tempControl = [];
    for (const domain of domains) {
      tempDomain.push({ label: domain.domainName, value: domain.domainCode });
    }
    for (const control of controls) {
      tempControl.push({
        label: control.controlName,
        value: control.domainCode
      });
    }
    setSelectDomains(tempDomain);
    setSelectControls(tempControl);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [domains, controls]);

  useEffect(() => {
    if (queryParameters.get('documentId')) {
      console.log('query ', queryParameters.get('documentId'));
      setCurrentDocId(queryParameters.get('documentId')!);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryParameters]);

  useEffect(() => {
    setSelectedControlOptions({ label: '', value: '' });
    setSelectedDomainOption({ label: '', value: '' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const addSelectionItem = (items: sentenceItem[]) => {
    console.log('items', items);
    console.log('select type', selectType);
    if (items.length === 0) {
      setCurrentText('');
      setSelectedItems([]);
      return;
    }
    if (selectType === 'multi') {
      // determine if the sentences are sequential.
      if (items.length > 1) {
        const sortedArray = items.sort(
          (a, b) => a.sentenceIndex - b.sentenceIndex
        );
        const firstSentenceIndex = sortedArray[0].sentenceIndex;
        const lastSentenceIndex = sortedArray[items.length - 1].sentenceIndex!;
        const forcedSelection = sentences.reduce((acc, curr) => {
          if (
            curr.sentenceIndex >= firstSentenceIndex &&
            curr.sentenceIndex <= lastSentenceIndex
          ) {
            acc.push(curr);
          }
          return acc;
        }, [] as sentenceItem[]);
        console.log('forced ', forcedSelection);
        setSelectedItems(forcedSelection); // this needs to change.
        const analysingText = forcedSelection.reduce(
          (acc: string, curr: { text: any }) => {
            acc += ` ${curr.text}`;
            return acc;
          },
          ''
        );
        setCurrentText(analysingText);
      } else {
        setSelectedItems(items);
        setCurrentText(items[0].text);
      }
    } else {
      if (items.length > 0) {
        setSelectedItems(items);
        setCurrentText(items[0].text);
      }
    }
  };

  const getFilteredDomain = (domain: string) => {
    const [filteredD] = selectDomains.filter(
      (ele) => ele.label.trim() === domain.trim()
    );
    setSelectedDomainOption(filteredD);
  };
  const setCurrentControl = () => {
    const [correctControl] = selectControls.filter(
      (ele) =>
        ele.label.trim() === selectedItems[0].predicted_label_control.trim()
    );
    console.log('fitered control', correctControl);
    setSelectedControlOptions(correctControl);
  };
  useEffect(() => {
    const updateValues = () => {
      if (selectedItems[0]?.predicted_label_domain) {
        getFilteredDomain(selectedItems[0].predicted_label_domain.trim());
      }
      if (selectedItems[0]?.predicted_label_control) {
        setCurrentControl();
      }
    };
    if (selectedItems.length > 0) {
      updateValues();
    } else {
      setSelectedDomainOption({ label: '', value: '' });
      setSelectedControlOptions({ label: '', value: '' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItems]);

  const getFilteredControlsB = (domain: string) => {
    console.log('controls filtered');
    const filteredC = selectControls.filter((ele) => ele.value === domain);
    setFilteredControlOptions(filteredC);
  };
  useEffect(() => {
    if (selectedDomainOption?.value) {
      getFilteredControlsB(selectedDomainOption.value!);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDomainOption]);
  const showUnParagraph = () => {
    if (selectedItems.length === 1 && 'sentences' in selectedItems[0]) {
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    if (filteringValue.length > 0) {
      const filterArray = filteringValue.map((ele) => ele.value);
      const accArray: sentenceItem[] = [];
      console.log('filter array', filterArray);
      // const temp = sentences.reduce((acc, curr) => {
      //       if (filterArray.includes('obligation') && filterArray.length > 1) {
      //         if(filterArray.includes(curr.predicted_label_language) && )

      //       } else {

      //       }
      //       return acc;
      // }, accArray );
      let temp: sentenceItem[] = [];
      if (filterArray.includes('Obligation')) {
        const obligations = sentences.filter(
          (ele) => ele.type === 'Obligation'
        );
        if (filterArray.length === 1) {
          temp = obligations;
        } else {
          temp = obligations.filter((ele) =>
            filterArray.includes(ele.predicted_label_language)
          );
        }
      } else {
        temp = sentences.filter((ele) =>
          filterArray.includes(ele.predicted_label_language)
        );
      }
      setFilteredSentences([...temp]);
    } else {
      setFilteredSentences([...sentences]);
    }
  }, [filteringValue, sentences]);

  useEffect(() => {
    console.log('selected domain', selectedItems[0]?.predicted_label_control);
    console.log('selecetd domain option', selectedDomainOption);
    console.log('selecetd control option', selectedControlOptions);
    if (selectType === 'single' && selectedItems?.length > 0) {
      if (
        ((selectedItems[0]?.predicted_label_domain?.trim() !==
          selectedDomainOption?.label ||
          selectedItems[0]?.predicted_label_control?.trim() !==
            selectedControlOptions?.label) &&
          selectedDomainOption?.value === selectedControlOptions?.value) ||
        notesValue !== selectedItems[0]?.notes
      ) {
        setShowSaveButton(true);
      } else {
        setShowSaveButton(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedControlOptions, selectedDomainOption, notesValue, sentences]);
  const getBurdenAttributionList = () => {
    const initailList = sentences.map((ele) => {
      const localArray = ele.burden_attribution.filter((ele) => ele !== 'None');
      return localArray;
    });
    const finalSet = Array.from(new Set(initailList.flat()));
    const stagingList = [];
    for (const att of finalSet) {
      stagingList.push({ label: att, value: att });
    }
    setBurdenAttribution(stagingList);
  };
  useEffect(() => {
    getBurdenAttributionList();
  }, [sentences]);

  return (
    <div style={{ maxHeight: '90vh', width: "100%" }}>
      <Container
        header={
          <SpaceBetween size="m">
            <Header
              variant="h1"
              actions={
                <SpaceBetween direction="horizontal" size="s">
                  <Button onClick={() => props.setShowSynopsis()}>
                    Synopsis
                  </Button>
                  {/* <Button variant="primary" onClick={() => exportSentences()}>
                    Create Report
                  </Button> */}
                </SpaceBetween>
              }
            >
              {currentDoc
                ? `Document Name: ${currentDoc.documentFileName}`
                : null}
            </Header>

            {/* <Alert>This is a generic alert.</Alert> */}
          </SpaceBetween>
        }
      >
        <SpaceBetween size="l" direction="vertical">
          <ExpandableSection
            variant="container"
            headerText="Analysis"
            expanded={showExpansion}
            onChange={({ detail }) => setShowExpansion(detail.expanded)}
            headerActions={
              showUnParagraph() ? (
                <Button onClick={() => breakPhraseApart()}>
                  Break Into Sentence
                </Button>
              ) : null
            }
          >
            <Container
              header={
                <Header
                  actions={
                    <>
                      {selectedItems.length === 1 ? (
                        <SpaceBetween direction="horizontal" size="xl">
                          <Select
                            selectedOption={selectedDomainOption}
                            onChange={({ detail }) =>
                              setSelectedDomainOption(detail.selectedOption)
                            }
                            options={selectDomains}
                          />
                          <Select
                            selectedOption={selectedControlOptions}
                            onChange={({ detail }) =>
                              setSelectedControlOptions(detail.selectedOption)
                            }
                            options={filteredControlOptions}
                          />
                        </SpaceBetween>
                      ) : null}
                      {selectedItems.length > 1 ? (
                        <Button onClick={() => createPhrase(selectedItems)}>
                          Analyse Paragraph
                        </Button>
                      ) : null}
                    </>
                  }
                >
                  Text
                </Header>
              }
              footer={
                showSaveButton ? (
                  <Button
                    loading={updateSentenceLoading}
                    variant="primary"
                    onClick={() => updateSentence()}
                  >
                    Save
                  </Button>
                ) : null
              }
            >
              <SpaceBetween direction="vertical" size="s">
                {selectedItems.length > 0 && (
                  <Box padding={'m'}>{currentText}</Box>
                )}
                {selectedItems.length > 0 &&
                selectedItems[0].redlineLog.length > 0 ? (
                  <ExpandableSection
                    variant="container"
                    headerText="Redline Actions"
                  >
                    <Textarea value={redlineNotes(selectedItems[0])} />
                  </ExpandableSection>
                ) : null}
                {selectedItems.length > 0 && (
                  <SpaceBetween size="m" direction="vertical">
                    <ExpandableSection variant="container" headerText="Notes">
                      <Textarea
                        onChange={({ detail }) => setNotesValue(detail.value)}
                        value={notesValue}
                        placeholder="You can type note here!"
                      />
                    </ExpandableSection>
                    {/* <Box variant="h3">Notes</Box> */}
                  </SpaceBetween>
                )}
              </SpaceBetween>
            </Container>
          </ExpandableSection>

          <Container
            header={
              <Header
                actions={
                  <>
                    <SpaceBetween size="s" direction="horizontal">
                      {/* <Multiselect
                        placeholder="Please select ownership"
                        selectedOptions={filteringValue}
                        options={burdenAttribution}
                        onChange={({ detail }) =>
                          setOwnershipFilteringValue([
                            ...detail.selectedOptions
                          ])
                        }
                      /> */}
                      <Multiselect
                        placeholder="Please select filter criteria"
                        selectedOptions={filteringValue}
                        options={[
                          { label: 'Compliance', value: 'ComplianceLanguage' },
                          { label: 'General', value: 'GeneralLanguage' },
                          { label: 'Obligation', value: 'Obligation' }
                        ]}
                        onChange={({ detail }) =>
                          setFilteringValue([...detail.selectedOptions])
                        }
                      />
                      {selectType === 'single' ? (
                        <SpaceBetween direction="horizontal" size="s">
                          {selectedItems.length > 0 && (
                            <Button
                              onClick={() => {
                                setSelectedItems([]);
                                setSelectType('single');
                                setShowExpansion(false);
                              }}
                            >
                              Clear
                            </Button>
                          )}
                          {selectedItems.length === 1 && (
                            <Button onClick={() => updateFocus()}>
                              Change Focus
                            </Button>
                          )}
                          {selectedItems.length === 1 && (
                            <Button onClick={() => updateRedline()}>
                              RedLine
                            </Button>
                          )}
                          <Button
                            onClick={() => {
                              setSelectType('multi');
                              setShowExpansion(false);
                            }}
                          >
                            Create paragraph
                          </Button>
                        </SpaceBetween>
                      ) : (
                        <SpaceBetween direction="horizontal" size="l">
                          <Button
                            disabled={selectedItems.length < 2}
                            variant="primary"
                            onClick={() => createPhrase(selectedItems)}
                          >
                            Analyse Paragraph
                          </Button>
                          {selectType === 'multi' ? (
                            <Button
                              onClick={() => {
                                setSelectedItems([]);
                                setSelectType('single');
                              }}
                            >
                              Clear
                            </Button>
                          ) : null}
                        </SpaceBetween>
                      )}
                    </SpaceBetween>
                  </>
                }
              ></Header>
            }
          >
            <div style={{ height: '60vh', overflow: 'scroll' }}>
              {currentDocId && sentences.length > 0 ? (
                <Table
                  loadingText="Loading resources"
                  sortingDisabled
                  variant="borderless"
                  items={items}
                  wrapLines
                  // resizableColumns
                  stickyHeader
                  selectedItems={selectedItems}
                  selectionType={selectType}
                  onSelectionChange={
                    ({ detail }) => addSelectionItem(detail.selectedItems)
                    // console.log('detail change', detail.selectedItems)
                  }
                  filter={<TextFilter {...filterProps} />}
                  columnDefinitions={[
                    {
                      id: 'text',
                      header: 'Document Sentences',
                      cell: (sentenceItem) => (
                        <p
                          style={{
                            textDecorationColor: 'red',
                            color: `${getRowColor(sentenceItem)}`,
                            textDecorationLine: `${
                              sentenceItem.redlined ? 'line-through' : 'none'
                            }`
                          }}
                        >
                          {sentenceItem.text}
                        </p>
                      ),
                      minWidth: '75%'
                    },

                    {
                      id: 'topic',
                      header: 'Parameters',
                      minWidth: '24%',
                      cell: (sentenceItem) => (
                        <p>
                          {sentenceItem.All_Parameters
                            ? sentenceItem.All_Parameters.join(',')
                            : ''}
                        </p>
                      )
                    },
                    {
                      id: 'kbIcon',
                      header: 'KB',
                      maxWidth: '1%',
                      cell: (sentenceItem) =>
                        sentenceItem.kbSentences.length > 0 ? <KBIcon /> : null
                    }
                  ]}
                  empty={
                    <Box
                      margin={{ vertical: 'xs' }}
                      textAlign="center"
                      color="inherit"
                    >
                      <SpaceBetween size="m">
                        <b>No matches</b>
                      </SpaceBetween>
                    </Box>
                  }
                />
              ) : (
                <Spinner size="large" />
              )}
            </div>
          </Container>
        </SpaceBetween>
      </Container>
    </div>
  );
};
